import Vue from 'vue';
import type { ActionTree, GetterTree, MutationTree } from 'vuex';
import type { HiringsState } from '~/types/store/hirings';
import type { RootState } from '~/types/store';
import type { JobsModeratorsHiring } from '~/types/graphql';
import { JobsVacancyEmployment } from '~/types/graphql';

export const state = (): HiringsState => ({
  selectedHiringsObj: {},
  submissionType: null,
});

export const actions: ActionTree<HiringsState, RootState> = {
  toggleSelectedHiring({ commit }, { hiring, isSelected }: { hiring: JobsModeratorsHiring; isSelected: boolean }) {
    if (isSelected) {
      commit('addHiring', { hiring });
      const isFlexVacancy = hiring.vacancy?.employmentType === JobsVacancyEmployment.SideHustle;
      commit('setSubmissionType', isFlexVacancy ? JobsVacancyEmployment.SideHustle : JobsVacancyEmployment.FullTime);
      return;
    }

    commit('removeHiring', hiring.id);
  },
  updateSubmissionType({ commit, getters }, type: JobsVacancyEmployment) {
    const hiringsToRemove =
      type === JobsVacancyEmployment.SideHustle ? getters.nonFlexSelectedHirings : getters.flexSelectedHirings;

    hiringsToRemove
      .map((h: JobsModeratorsHiring) => h.id)
      .forEach((hiringId: string) => {
        commit('removeHiring', hiringId);
      });
    commit('setSubmissionType', type);
  },
};

export const getters: GetterTree<HiringsState, RootState> = {
  selectedHirings(state): Array<JobsModeratorsHiring> {
    return Object.values(state.selectedHiringsObj);
  },
  selectedHiringIds(state): Array<string> {
    return Object.keys(state.selectedHiringsObj);
  },
  selectedHiringIdsCount(state, getters) {
    return getters.selectedHirings.length;
  },
  flexSelectedHirings(state, getters): Array<JobsModeratorsHiring> {
    return getters.selectedHirings.filter(
      (h: JobsModeratorsHiring) => h.vacancy?.employmentType === JobsVacancyEmployment.SideHustle,
    );
  },
  nonFlexSelectedHirings(state, getters): Array<JobsModeratorsHiring> {
    return getters.selectedHirings.filter(
      (h: JobsModeratorsHiring) => h.vacancy?.employmentType !== JobsVacancyEmployment.SideHustle,
    );
  },
};

export const mutations: MutationTree<HiringsState> = {
  addHiring(state, { hiring }): void {
    Vue.set(state.selectedHiringsObj, hiring.id, hiring);
  },
  removeHiring(state, hiringId): void {
    Vue.delete(state.selectedHiringsObj, hiringId);
  },
  resetSelectedHirings(state) {
    state.selectedHiringsObj = {};
  },
  setSubmissionType(state, submissionType: JobsVacancyEmployment) {
    state.submissionType = submissionType;
  },
};
